"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (muiTheme) {
  if (muiTheme.userAgent !== false) {
    return function (style) {
      return muiTheme.prefix(style);
    };
  }
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/lib/styles/transformers/autoprefixer.js
// module id = 668
// module chunks = 0